export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What document contains ISACA audit standards, audit guidelines, and the code of ethics?",
    "description": "Information Technology Audit Framework (ITAF)."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What are the two types of controls that either block an unwanted activity or identify an unwanted activity?",
    "description": "Preventive and detective."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What is a broad statement describing the purpose of a group of similar controls?",
    "description": "Control objective."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What is the name of a set of controls that apply to all systems?",
    "description": "General Computing Controls (GCCs) or IT General Controls (ITGCs)."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What type of audit examines the existence and effectiveness of IS controls?",
    "description": "Operational audit."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What type of audit is performed in support of an active legal proceeding?",
    "description": "Forensic audit."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "What type of audit report would an organization make of one of its service providers?",
    "description": "System and Organization Controls (SOC) audit."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What type of testing is used to determine the accuracy and integrity of transactions that flow through processes and information systems?",
    "description": "Substantive testing."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What characteristic of an auditor is related to the auditor\u2019s freedom from the consequences of an audit result?",
    "description": "Independence."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What type of audit testing consists of an auditor conducting interviews with control owners to understand the process?",
    "description": "Walk-through / Inquiry."
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "What type of audit testing consists of an auditor watching control owners operate their controls?",
    "description": "Observation."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "What type of audit testing involves an auditor discussing control operation with additional persons?",
    "description": "Corroboration."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "What type of audit testing consists of an auditor performing transaction calculations independently of the control owner/system to ensure that they get the same results as the system processing the same transaction?",
    "description": "Re-performance."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What is the term used to denote an entire set of evidence that is related to a control to be sampled from?",
    "description": "Population."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What term refers to a method used to select a subset of transactions in a population?",
    "description": "Sampling."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "What type of sampling involves a random selection of samples?",
    "description": "Statistical."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "What type of sampling involves the auditor selecting samples based on some criteria?",
    "description": "Judgmental."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What type of sampling involves an auditor who is trying to find at least one exception in a population?",
    "description": "Discovery."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What term is used to denote the use of test scripts, debugging software, scanning software, and running test transactions?",
    "description": "Computer-assisted audit techniques (CAATs)."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What term is used to express a level of impact that is quantified in terms of currency?",
    "description": "Materiality."
  },
  {
    "id": 21,
    "topic_id": 1,
    "title": "What term is used to denote a test of a control in which the control owner answers questions and provides evidence?",
    "description": "Control self-assessment or test of design."
  },
  {
    "id": 22,
    "topic_id": 4,
    "title": "What is the term that denotes the management of the amount of resources available in information systems?",
    "description": "Capacity management."
  },
  {
    "id": 23,
    "topic_id": 4,
    "title": "What is an unplanned interruption of an IT service known as?",
    "description": "Incident."
  },
  {
    "id": 24,
    "topic_id": 4,
    "title": "What is a series of incidents known as?",
    "description": "Problem."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What UK-based standard consists of all of the fundamental processes in an IT department?",
    "description": "IT Service Management (ITSM)."
  },
  {
    "id": 26,
    "topic_id": 4,
    "title": "What process is used to manage modifications to a set of systems?",
    "description": "Change management."
  },
  {
    "id": 27,
    "topic_id": 4,
    "title": "What are the steps in a typical change management process?",
    "description": "1. Request <br>2. Review <br>3. Approve <br>4. Implementation <br>5. Verification <br>6. Post-change review."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What are the steps in a typical systems development life cycle (SDLC) process?",
    "description": "1. Feasibility study <br>2. Requirements <br>3. Design <br>4. Development <br>5. Testing <br>6. Implementation <br>7. Maintenance <br>8. Retirement."
  },
  {
    "id": 29,
    "topic_id": 5,
    "title": "What process is used to identify weaknesses in systems?",
    "description": "Vulnerability management."
  },
  {
    "id": 30,
    "topic_id": 4,
    "title": "What is the step in business continuity planning in which critical business processes are identified and studied?",
    "description": "Business impact analysis (BIA)."
  },
  {
    "id": 31,
    "topic_id": 4,
    "title": "How often should a disaster recovery plan (DRP) be reviewed and updated?",
    "description": "At least once per year or when significant changes are made to information systems."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What is the name of the theoretical time interval that represents the duration of a disaster that puts the organization\u2019s survival at risk?",
    "description": "Maximum tolerable downtime (MTD)."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "What is the definition of recovery time objective (RTO)?",
    "description": "The maximum period of time that elapses from the onset of a disaster until the resumption of service."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "In disaster response, what is the number one priority?",
    "description": "The safety of personnel."
  },
  {
    "id": 35,
    "topic_id": 4,
    "title": "What action triggers the start of a response to a disaster or incident?",
    "description": "Declaration."
  },
  {
    "id": 36,
    "topic_id": 4,
    "title": "What is the set of procedures to be followed when supporting information systems are unavailable called?",
    "description": "Business continuity plan (BCP)."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "What is a test of a disaster recovery plan in which alternate processing systems assume live production transaction processing known as?",
    "description": "Cutover test."
  },
  {
    "id": 38,
    "topic_id": 4,
    "title": "What is the set of procedures to be followed to transition production transaction processing to an alternate system known as?",
    "description": "Disaster recovery plan (DRP)."
  },
  {
    "id": 39,
    "topic_id": 4,
    "title": "In a disaster recovery plan, what term is used to denote the examination of assets to determine whether they can be repaired?",
    "description": "Salvage."
  },
  {
    "id": 40,
    "topic_id": 4,
    "title": "What is the name of an alternate processing site with information systems ready to perform production processing with little or no notice?",
    "description": "Hot site."
  },
  {
    "id": 41,
    "topic_id": 4,
    "title": "What problem could occur when an organization establishes its hot site in the same city as the main production site?",
    "description": "A regional disaster could affect both sites."
  },
  {
    "id": 42,
    "topic_id": 4,
    "title": "What is a collection of two or more servers that function as a single server resource known as?",
    "description": "Server cluster."
  },
  {
    "id": 43,
    "topic_id": 5,
    "title": "What is the name of the technology in which multiple operating systems can run independently on a single server?",
    "description": "Virtualization."
  },
  {
    "id": 44,
    "topic_id": 4,
    "title": "What is the term for FAT, NTFS, APFS, and UDF?",
    "description": "Filesystems."
  },
  {
    "id": 45,
    "topic_id": 5,
    "title": "What term is used to denote the layered design of network protocols?",
    "description": "Encapsulation."
  },
  {
    "id": 46,
    "topic_id": 5,
    "title": "What is the name of a node\u2019s address at the Link layer in TCP/IP?",
    "description": "MAC address."
  },
  {
    "id": 47,
    "topic_id": 5,
    "title": "What is the name of the protocol family in TCP/IP in which a receiving station sends an acknowledgment for each packet received?",
    "description": "Transmission Control Protocol (TCP)."
  },
  {
    "id": 48,
    "topic_id": 5,
    "title": "Why are the TELNET and FTP protocols considered obsolete?",
    "description": "Both protocols transmit authentication information in plaintext (not encrypted)."
  },
  {
    "id": 49,
    "topic_id": 5,
    "title": "What system collects and analyzes log data from many systems and devices?",
    "description": "Security information and event management system (SIEM)."
  },
  {
    "id": 50,
    "topic_id": 4,
    "title": "What IT business process is essential to support the vulnerability and configuration management processes?",
    "description": "Asset management."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What are the five domains of COBIT?",
    "description": "1. Evaluate, Direct, and Monitor <br>2. Align, Plan, and Organize <br>3. Build, Acquire, and Implement <br>4. Deliver, Service, and Support <br>5. Monitor, Evaluate, and Assess."
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "What are the four perspectives included on the IT balanced scorecard?",
    "description": "1. Business contribution <br>2. User <br>3. Operational excellence <br>4. Innovation."
  },
  {
    "id": 53,
    "topic_id": 2,
    "title": "Who is responsible for establishing the tone for risk appetite and risk management in the organization?",
    "description": "Board of directors."
  },
  {
    "id": 54,
    "topic_id": 2,
    "title": "Who is responsible for overall leadership of the IT organization?",
    "description": "The chief information officer (CIO)."
  },
  {
    "id": 55,
    "topic_id": 2,
    "title": "What are some of the common topics covered by an information security policy?",
    "description": "Roles and responsibilities <br>Risk management <br>Security processes <br>Acceptable use."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "What type of information is governed by a privacy policy?",
    "description": "Personally identifiable information (PII)."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "What are the information classification levels used by the U.S. government?",
    "description": "Top Secret <br>Secret <br>Confidential <br>Unclassified."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "What tool is commonly used to show how information moves between IT systems?",
    "description": "Data flow diagram (DFD)."
  },
  {
    "id": 59,
    "topic_id": 5,
    "title": "In what architectural philosophy are one or more portions of an environment considered untrusted?",
    "description": "Zero trust."
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "What are the four risk treatment options?",
    "description": "Accept <br>Mitigate (reduce)<br>Transfer (share)<br>Avoid."
  },
  {
    "id": 61,
    "topic_id": 2,
    "title": "What are the three components of ISACA\u2019s Risk IT Framework?",
    "description": "Risk Governance <br>Risk Evaluation <br>Risk Response."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "What formula is typically used to describe the components of a risk?",
    "description": "Risk = Probability * Impact."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "How do you compute the annualized loss expectancy?",
    "description": "ALE = SLE * ARO <br>ALE = Annualized Loss ExpectancySLE = Single Loss ExpectancyARO = Annual Rate of Occurrence."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "How do you compute the single loss expectancy?",
    "description": "SLE = AV  EF <br>SLE = Single Loss ExpectancyAV = Asset ValueEF = Exposure Factor."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "How do you compute the residual risk?",
    "description": "Residual Risk = Original Risk \u2013 Mitigated Risk \u2013 Transferred Risk."
  },
  {
    "id": 66,
    "topic_id": 5,
    "title": "What are the three most common cloud service models?",
    "description": "SaaS (software-as-a-service), IaaS (infrastructure-as-a-service), and PaaS (platform-as-a-service)."
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "What are the common steps of a change management process?",
    "description": "1. Request <br>2. Review <br>3. Approve/Deny <br>4. Perform <br>5. Verify <br>6. Back out (if necessary)<br>What term is used for metrics that demonstrate the success of the security program in achieving its objectives?"
  },
  {
    "id": 68,
    "topic_id": 1,
    "title": "What document defines the objectives of a program, its main timelines, the sources of funding, the names of its principal leaders and managers, and the names of the business executive or executives who are sponsoring the program?",
    "description": "Charter."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "What term describes an organization\u2019s entire set of active projects at any given time?",
    "description": "Project portfolio."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "What are the characteristics of a SMART goal?",
    "description": "Specific, measurable, achievable, relevant, and time-bound."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "What tool represents the components of the project in graphical or tabular form?",
    "description": "Object breakdown structure (OBS)."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "What are the four roles in a RACI matrix?",
    "description": "ResponsibleAccountableConsultedInformed."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "What are the five metrics used to conduct a function point analysis?",
    "description": "User inputs, user outputs, user queries, files, and external interfaces."
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "What are the PMBOK delivery principles?",
    "description": "Stewardship <br>Team <br>Stakeholders <br>Value <br>HolisticThinking <br>Quality <br>Complexity <br>Leadership <br>Tailoring <br>Opportunities & Threats <br>Adaptability & Resilience <br>Change Management."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "What are the three questions asked during a daily scrum?",
    "description": "1.What have you done since yesterday?<br>2.What are you planning to do by tomorrow?<br>3.What obstacles are preventing you from completing your work?"
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What are the four principles of the Agile Manifesto?",
    "description": "Individuals and interactions over processes and tools <br>Working software over comprehensive documentation <br>Customer collaboration over contract negotiation <br>Responding to change over following a plan."
  },
  {
    "id": 77,
    "topic_id": 2,
    "title": "What document is used to solicit bids from vendors for a project?",
    "description": "Request for proposals (RFP)."
  },
  {
    "id": 78,
    "topic_id": 5,
    "title": "What are the three goals of information security?",
    "description": "Confidentiality <br>Integrity <br>Availability."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "What title is normally given to the most senior information security leader within an organization?",
    "description": "Chief information security officer (CISO)."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "What are the different categories of security risk?",
    "description": "Financial <br>Reputational <br>Strategic <br>Operational <br>Compliance."
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "What are the components of a SWOT analysis?",
    "description": "Strengths <br>Weaknesses <br>Opportunities <br>Threats."
  },
  {
    "id": 82,
    "topic_id": 2,
    "title": "What term is given to third-party organizations that handle data on behalf of a data owner?",
    "description": "Data processors."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "What are the major categories of security controls?",
    "description": "Technical <br>Operational <br>Managerial."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "What are the major types of security controls?",
    "description": "Preventive <br>Detective <br>Corrective <br>Deterrent <br>Physical <br>Compensating."
  },
  {
    "id": 85,
    "topic_id": 5,
    "title": "What are the two types of errors that may be made by an intrusion detection system?",
    "description": "False negative <br>False positive."
  },
  {
    "id": 86,
    "topic_id": 5,
    "title": "What is the primary purpose of a digital certificate?",
    "description": "To securely provide a public encryption key."
  },
  {
    "id": 87,
    "topic_id": 5,
    "title": "What are the phases of security incident response?",
    "description": "Preparation <br>Detection and Analysis <br>Containment, Eradication, and Recovery <br>Post-Incident Activity."
  },
  {
    "id": 88,
    "topic_id": 5,
    "title": "What principle says that an individual user should have the lowest privilege possible that will still enable them to perform required tasks?",
    "description": "Least privilege."
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "What concept specifies that single individuals should not have combinations of privileges that would permit them to conduct high-value operations on their own?",
    "description": "Segregation of duties (or separation of duties)."
  },
  {
    "id": 90,
    "topic_id": 5,
    "title": "In what access model is the owner of an object able to determine how and by whom the object may be accessed?",
    "description": "Discretionary access control (DAC)."
  },
  {
    "id": 91,
    "topic_id": 5,
    "title": "What are the three steps of the access control process?",
    "description": "1. Identification <br>2. Authentication <br>3. Authorization."
  },
  {
    "id": 92,
    "topic_id": 5,
    "title": "What are the three authentication factors?",
    "description": "Something you know <br>Something you have <br>Something you are."
  },
  {
    "id": 93,
    "topic_id": 5,
    "title": "What is the best metric to use to evaluate the effectiveness of an access control system?",
    "description": "Crossover error rate (CER)."
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "What type of condition occurs when there is a sustained drop in electrical voltage over several hours?",
    "description": "Brownout."
  },
  {
    "id": 95,
    "topic_id": 4,
    "title": "What type of device is suitable for providing backup power during an extended outage?",
    "description": "Generator."
  },
  {
    "id": 96,
    "topic_id": 5,
    "title": "What type of fire suppression system is the best choice for use in a data center?",
    "description": "Inert gas."
  },
  {
    "id": 97,
    "topic_id": 5,
    "title": "What is the typical temperature range for a data center?",
    "description": "64.4\u00b0 to 80.6\u00b0F (18\u00b0 to 27\u00b0C)."
  },
  {
    "id": 98,
    "topic_id": 5,
    "title": "What are the three most common cloud deployment models?",
    "description": "Public cloud <br>Private cloud <br>Hybrid cloud."
  },
  {
    "id": 99,
    "topic_id": 5,
    "title": "What model describes how security duties are divided in a cloud vendor/customer relationship?",
    "description": "Shared responsibility model."
  },
  {
    "id": 100,
    "topic_id": 200,
    "title": "Know how metrics are used to assess the efficiency and effectiveness of the information security program.",
    "description": "Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs look at historical performance. Key goal indicators (KGIs) measure progress toward defined goals. Key risk indicators (KRIs) try to quantify the security risk facing an organization. KRIs look forward at future potential risks."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Understand the roles and responsibilities for IT governance.",
    "description": "IT executives and the board of directors are responsible for imposing an IT governance model encompassing IT strategy, information security, and formal enterprise architectural mandates. Strategic planning is accomplished by a steering committee, addressing the near-term and long-term requirements aligning business objectives and technology strategies."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Know the role that governance documents play in an organization.",
    "description": "Policies, procedures, and standards enable validation of business practices against acceptable measures of regulatory compliance, performance, and standard operational guidelines."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Describe the purpose of a risk management program.",
    "description": "Risk management involves the identification of potential risks and the appropriate responses for each risk based on impact assessment using qualitative and/or quantitative measures for an enterprise-wide risk management strategy."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Know the responsibilities of IT managers.",
    "description": "Assigned IT management roles ensure that resource allocation, enterprise performance, and operational capabilities coordinate with business requirements by validating alignment with standards and procedures for change management and compliance with sourcing, financial, quality, and security controls."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Describe the purpose of an organizational structure.",
    "description": "Formal organizational structure ensures alignment between operational roles and responsibilities within the enterprise, where a separation of duties ensures individual accountability and validation of policy alignment between coordinated team members."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Understand the role of auditing in the IT governance process.",
    "description": "Regular auditing of the IT governance process ensures alignment with regulatory and business mandates in the evolving enterprise by ensuring that all documentation, contracts, and sourcing policies are reviewed and updated to meet changes in the living enterprise."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Be able to explain the various categories of controls.",
    "description": "Controls are categorized in several ways. Detective and preventive refer to whether a control can prevent unwanted outcomes or merely detect them. Controls can be categorized as automatic or manual, which refers to whether a control is automated or must be invoked manually. Controls can be categorized as deterrent, which usually means the control is visible and exists to discourage violations. Controls can be categorized as corrective, compensating, and/or recovery, all related to actions taken when things go wrong. Finally, controls often have multiple categories. For example, a security-controlled door lock can be considered automatic, preventive, and deterrent."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Know the various techniques used in sampling.",
    "description": "When a set of records is too large for an auditor to examine each one, the auditor must choose a sampling technique to select the records to examine. Statistical sampling employs a strictly random selection of records. Discovery sampling is used to detect fraud. Stratified sampling is used to select samples with, for example, low, moderate, and high dollar figures. Attribute sampling involves an examination of one or more values to understand control performance, such as the time required to patch a system. Judgmental sampling is used when auditors select samples manually based on established criteria."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Be familiar with ISACA audit standards and audit guidelines.",
    "description": "ISACA audit standards are considered mandatory whenever a CISA-certified individual plans or performs audits. The standards are a set of audit rules that auditors must follow. ISACA audit guidelines provide additional guidance to auditors and are considered optional."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Audit plans should be at least partially risk-driven.",
    "description": "IS auditors generally put more audit resources into higher-risk processes and controls. The relative risk level can be determined from an up-front risk assessment, the results of prior audits, recent security events or incidents, the introduction of new processes or systems, new laws and regulations, or any combination of these factors."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "AI and ML provide needed assistance to auditors examining large datasets.",
    "description": "Artificial intelligence (AI) and machine learning (ML) tools can streamline auditors\u2019 study of large datasets, saving time and providing additional insights. Auditors must first ensure that the use of AI/ML tools is permitted by policy and applicable laws and does not endanger the confidentiality of sensitive information."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "The auditor\u2013auditee relationship should be collaborative, not adversarial.",
    "description": "Too many organizations see auditors as nit-picking adversaries who point out every flaw. While it is true that the auditors\u2019 role is to objectively opine on the effectiveness of controls, a preferred mindset is to consider auditors as collaborators or partners rather than enemies."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Understand how organizations realize business benefits.",
    "description": "Benefits realization is the result of strategic planning, process development, and systems development, which all contribute toward a launch of business operations to reach a set of business objectives."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Know the project management strategies and their impact on program execution.",
    "description": "Project management strategies guide program execution through the organization of resources and development of clear project objectives. Management of the project schedule, roles, change management, and subsequent completion or closure criteria determine the outcome of each project. Many project management methodologies exist to guide project expectations, requirements, and completion criteria."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Explain the systems development life cycle (SDLC) and its importance in application software creation.",
    "description": "The systems development life cycle (SDLC) defines a subset of project management focusing on the requirements for the creation, implementation, and maintenance of application software. The SDLC relies on a sequence of events that may occur one time or cyclically as part of a formal continual improvement process. The SDLC phases include a feasibility study, definition of requirements, design, development, testing, implementation, and post-implementation."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Describe the role of enterprise infrastructure in facilitating application access and its development process.",
    "description": "Application access is facilitated by the enterprise infrastructure, which is in turn developed, implemented, and maintained through a process similar to the SDLC. Infrastructural development begins with a review of existing infrastructure elements, matching each to identified requirements to produce the initial design. After procurement to meet design requirements, the activities of testing, implementation, and post-implementation follow similarly to the SDLC."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Understand post-implementation maintenance of information systems.",
    "description": "Post-implementation maintenance of information systems includes both change and configuration management strategies to ensure the enterprise remains aligned with business requirements and practices."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Explain the business process life cycle (BPLC) and business process reengineering (BPR).",
    "description": "The business process life cycle (BPLC) and business process reengineering (BPR) aid in coordinating business processes using a sequence of events similar to that of the SDLC focused on business process creation, implementation, and maintenance. Benchmarking facilitates continuous improvement within the BPLC, while capability maturity models can enable point-in-time assessment of business process and information system capability alignment."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Know the importance of application controls and their role in information systems.",
    "description": "Application controls limit information system access at the point of entry (input controls), during consumption (process controls), and at the point of expression (output controls)."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Describe the process of auditing the enterprise\u2019s development life cycle.",
    "description": "Auditing each element of the enterprise\u2019s development life cycle validates alignment between business and regulatory controls against process and functional control strategies and standards. The auditor should be familiar with the project management strategy in place within an enterprise to ensure that both the elements and the process used to develop each are properly aligned with business process requirements."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Explain the importance of auditing application controls and the role of CAATs.",
    "description": "Auditing application controls validates the proper operation of input, process, and output controls by following transaction flow from initiation through conclusion and performing data integrity testing appropriate to the application design. Computer-assisted audit techniques (CAATs) systems are particularly useful for the continuous audit of application controls."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Be able to explain why IT operations processes should be formalized.",
    "description": "IT operations processes and procedures should be written down and periodically reviewed. They should also be measured and reported so management can better understand ongoing IT operations."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Know the methods used to manage and measure system performance.",
    "description": "Key processes, including availability and capacity management, ensure that IT systems\u2019 availability is measured and as high as needed. Capacity management ensures that IT systems have sufficient resources for IT systems and applications have sufficient capacity to continue operating without exhausting critical resources such as CPU, storage, and network throughput."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Know how system monitoring helps IT personnel be aware of anomalies and incidents.",
    "description": "System monitoring helps IT personnel be informed of anomalies, malfunctions, system health, and capacity issues. An IT department should be aware of these issues through tooling and monitoring, instead of relying on end users to inform them."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Understand the common types of security monitoring.",
    "description": "Security monitoring of devices, including firewalls, intrusion prevention systems, data loss prevention systems, file integrity monitoring systems, and many others provide security personnel with a continuous awareness of the environment\u2019s security posture."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Be able to explain how incident and problem management are related.",
    "description": "Incident management is related to individual events representing malfunctions, outages, and other anomalies. When any incident becomes chronic, problem management seeks to identify the root cause and stop it from occurring."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Know the critical nature of change and configuration management.",
    "description": "Change management is the life cycle process through which all changes to IT systems are processed in a formal request, review, approve, implement, verify, and closure process. Configuration management is a process that catalogs the configuration settings of all IT systems and devices."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Be able to explain vulnerability and patch management.",
    "description": "Vulnerability management is a highly critical life cycle process that ensures that exploitable vulnerabilities in systems and devices are remediated promptly and effectively. Effective vulnerability management greatly reduces the likelihood and impact of break-ins that exploit known vulnerabilities."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Know the value of log management in IT and security operations.",
    "description": "Log management is another cornerstone activity for organizations to quickly be aware of attacks, attempted intrusions, and employee misbehavior. It is important to understand all the types of available logs, and the vital elements that should be a part of every log entry."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Understand the value of service level management.",
    "description": "Service level management helps IT management understand the degree to which the IT department performs according to its service level agreements (SLAs)."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Understand the structure and management of database management systems (DBMSs).",
    "description": "Database management systems are the backend of virtually every business application, even those running on mobile devices. DBMSs are nearly as complex as operating systems, with broad and complex configurability, user management, log management, and access control."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Know about data governance and management.",
    "description": "Data governance is an oversight function that ensures data is used in agreed-on ways. Data governance is vital for the protection of intellectual property as well as privacy. Data management consists of various processes used to carry out data governance directives. This differs from data quality, which covers the completeness and accuracy of the data and processes around ensuring that the data is reliable so that management can rely upon it."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Understand the functions of information technology.",
    "description": "From the very small (operating systems, network concepts) to the very large (architectures, how the Internet works), IS auditors need to have the best possible understanding of the functionality of computer components, operating systems, filesystems, storage systems, networks, applications, and interfaces). Gaps in this knowledge can mean that unsafe practices may be overlooked."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Understand the management of information technology.",
    "description": "IS auditors need to understand how information technology should be managed, to ensure that IT environments are trusted and reliable."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Be able to explain the OSI and TCP/IP network models.",
    "description": "IS auditors must be familiar with OSI and TCP/IP network models, including encapsulation, protocols, and how they contribute to network technology. Auditors with this knowledge will be more likely to detect unsafe practices."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Understand the intricacies of the global Internet.",
    "description": "Virtually all organizations are connected to the global Internet, and rely on that connection for some (if not all) of their IT systems to function. Thus, it\u2019s imperative that IS auditors understand Internet functionality in detail, to help identify both good and bad practices."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Be able to explain why asset management is critical.",
    "description": "IS auditors must have a solid understanding of asset inventory and asset management, including knowledge of the other IT- and cybersecurity-related processes which rely on sound asset management. Asset management is not only hardware, but software, data, workers, vendors, service providers, work centers, and more."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Be familiar with job processing, automation, and interfaces.",
    "description": "It\u2019s critical for IS auditors to understand how modern job processing (scheduled jobs for backup, file transfer, and other maintenance) is managed in IT organizations. Much job processing involves IT systems and business applications communicating with systems and applications outside the organization; hence, IS auditors need to understand how this communication is managed and protected."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Know how end-user endpoints are managed and used.",
    "description": "End-user computing is a vital part of information technology. Without end-user computing, we would not be able to access and use business applications. IS auditors need to understand modern endpoint management tools and practices to ensure they do not introduce risks to the organization. Lacking mature enterprise management controls and antimalware tools, and being small enough to easily lose, mobile devices are a popular attack target. The IS auditor needs to understand how the organization addresses these matters."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Be able to recognize shadow IT.",
    "description": "Shadow IT, the unsanctioned use of computers, software, and cloud services, lurks in nearly every organization. IS auditors must understand management\u2019s approach to shadow IT and any safeguards that are in place to prevent it."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Understand the business impact analysis (BIA) process and its relationship with BC and DR planning.",
    "description": "Business impact analysis (BIA) is used to determine the dependencies of business processes and information systems and their relative criticality. One output of a BIA is a set of recovery targets (RTO, RPO, RCapO, RCO, etc.) that determine how quickly a system should be recovered."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Be able to explain how BC planning and DR planning complement each other.",
    "description": "Business continuity (BC) planning involves the continuation of critical business processes with alternate systems, alternate work locations, alternate personnel, or any combination of these. Disaster recovery (DR) planning involves the assessment and recovery of processing systems, including the implementation of recovery (alternate) systems, the recovery of the primary system, and the eventual resumption of processing on the primary system (or a replacement if it is damaged beyond repair)."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Know how recovery targets (RTO, RPO, RCapO, RCO, etc.) function.",
    "description": "Recovery time objective (RTO) is the maximum period that elapses from the onset of a disaster until the resumption of service. Recovery point objective (RPO) is the maximum data loss from the onset of a disaster. Recovery capacity objective (RCapO) is the transaction or storage capacity of the recovery system as compared to the primary system. Recovery consistency objective (RCO) refers to the consistency or completeness of the recovery system, as compared to the primary system. Service delivery objective (SDO) refers to some aspect of service delivery such as SLAs."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Understand how BC and DR plans are tested.",
    "description": "BC and DR plans must be tested to validate effectiveness through document review, walk-through, simulation, parallel testing, or cutover testing practices. Regular testing must take place to ensure new objectives and procedures meet the requirements of a living enterprise environment. Participation in these tests provides familiarity and training for engaged operational staff members, raising understanding and awareness of requirements and responsibilities."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Be able to explain resilient IT architecture and resilient devices.",
    "description": "Resilient IT architecture often involves the use of redundant systems and data paths, so that the complete failure of any individual system or device will not result in the cessation of processing. Resilient devices have redundant components such as power supplies, network interfaces, storage devices, and processors. Many resilient devices permit a \u201chot swap\u201d of individual components that do not interrupt the system\u2019s processing."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Be able to explain various data replication and data backup technologies.",
    "description": "Data can be replicated from one storage system to another, whether located in the same facility or in another location. It can also be backed up to tape, virtual tape libraries (VTLs), hard drives, or e-vaulted (stored in the cloud). Various backup media rotation schemes are used to efficiently back up data at several points in time."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Understand crisis management and its relationship with BC and DR planning.",
    "description": "Crisis management is used by organizations to respond to various business emergencies. It can provide templates and techniques for communications and escalation, helping to simplify the overall effort of responding to all kinds of business emergencies."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Know the role of endpoint security technologies in an enterprise cybersecurity program.",
    "description": "Antimalware software protects endpoint devices from many different threats. Antimalware software uses signature detection and heuristic detection to prevent malware infections. Endpoint detection and response (EDR) platforms manage the detection, containment, investigation, and remediation of endpoint security incidents. Data loss prevention (DLP) systems prevent the unauthorized exfiltration of sensitive data. Change and configuration management systems maintain secure system configurations, whereas patch management ensures that security updates are consistently applied. System hardening techniques close holes that might be exploited by an attacker."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Explain the role of network segmentation.",
    "description": "Network segmentation techniques place systems and users of different security levels on different network segments, containing the damage caused by a potential security incident. Firewalls provide segmentation of networks into security zones, whereas VLANs group users and devices by function."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Understand the security requirements for routers, switches, and other network devices.",
    "description": "Routers and switches must be protected against unauthorized physical access to avoid compromise. Switch security techniques include VLAN pruning, the prevention of VLAN hopping, and port security. Router security techniques include the use of access control lists to filter traffic and quality of service controls to prioritize important network use."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Explain the three major cloud service models.",
    "description": "In the anything-as-a-service (XaaS) approach to computing, there are three major cloud service models. Infrastructure-as-a-service (IaaS) offerings allow customers to purchase and interact with the basic building blocks of a technology infrastructure. Software-as-a-service (SaaS) offerings provide customers with access to a fully managed application running in the cloud. Platform-as-a-service (PaaS) offerings provide a platform where customers may run applications that they have developed themselves."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Describe the four major cloud deployment models.",
    "description": "Public cloud service providers deploy infrastructure and then make it accessible to any customers who wish to take advantage of it in a multitenant model. The term private cloud is used to describe any cloud infrastructure that is provisioned for use by a single customer. A community cloud service shares characteristics of both the public and private models. Community cloud services do run in a multitenant environment, but the tenants are limited to members of a specifically designed community. Hybrid cloud is a catch-all term used to describe cloud deployments that blend public, private, and/or community cloud services together."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Understand the shared responsibility model of cloud security.",
    "description": "Under the shared responsibility model of cloud security, cloud customers must divide responsibilities between one or more service providers and the customers\u2019 own cybersecurity teams. In an IaaS environment, the cloud provider takes on the most responsibility, providing security for everything below the operating system layer. In PaaS, the cloud provider takes over added responsibility for the security of the operating system itself. In SaaS, the cloud provider is responsible for the security of the entire environment, except for the configuration of access controls within the application and the choice of data to store in the service."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Understand the goals of cryptography.",
    "description": "The four goals of cryptography are confidentiality, integrity, authentication, and nonrepudiation. Confidentiality is the use of encryption to protect sensitive information from prying eyes. Integrity is the use of cryptography to ensure that data is not maliciously or unintentionally altered. Authentication refers to uses of encryption to validate the identity of individuals. Nonrepudiation ensures that individuals can prove to a third party that a message came from its purported sender."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Explain the differences between symmetric and asymmetric encryption.",
    "description": "Symmetric encryption uses the same shared secret key to encrypt and decrypt information. Users must have some mechanism to exchange these shared secret keys. The Diffie\u2013Hellman algorithm provides one approach. Asymmetric encryption provides each user with a pair of keys: a public key, which is freely shared, and a private key, which is kept secret. Anything encrypted with one key from the pair may be decrypted with the other key from the same pair."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Explain how digital signatures provide nonrepudiation.",
    "description": "Digital signatures provide nonrepudiation by allowing a third party to verify the authenticity of a message. Senders create digital signatures by using a hash function to generate a message digest and then encrypting that digest with their own private key. Others may verify the digital signature by decrypting it with the sender\u2019s public key and comparing this decrypted message digest to one that they compute themselves using the hash function on the message."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Understand the purpose and use of digital certificates.",
    "description": "Digital certificates provide a trusted mechanism for sharing public keys with other individuals. Users and organizations obtain digital certificates from certificate authorities (CAs), who demonstrate their trust in the certificate by applying their digital signature. Recipients of the digital certificate can rely on the public key it contains if they trust the issuing CA and verify the CA\u2019s digital signature."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Security events are occurrences that may escalate into a security incident.",
    "description": "An event is any observable occurrence in a system or network. A security event includes any observable occurrence that relates to a security function. A security incident is a violation or imminent threat of violation of computer security policies, acceptable use policies, or standard security practices. Every incident consists of one or more event, but every event is not an incident."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "The cybersecurity incident response process has four phases.",
    "description": "The four phases of incident response are preparation; detection and analysis; containment, eradication, and recovery; and post-incident activities. The process is not a simple progression of steps from start to finish. Instead, it includes loops that allow responders to return to prior phases as needed during the response."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Know the role of access controls in an enterprise cybersecurity program.",
    "description": "Access controls are technology-based methods of controlling access to an information-based resource. They must be actively managed by authorized staff. Logical access controls determine whether and how subjects (persons, programs, computers) can access objects (systems, data). Examples include user authentication (e.g., user ID and password) and service access controls (e.g., firewalls). Access control models include Mandatory Access Control (MAC) and Discretionary Access Control (DAC), each with its own advantages and disadvantages."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Explain access control threats and vulnerabilities.",
    "description": "Threats to access controls include malware, eavesdropping, logic bombs, back doors, scanning attacks, and race conditions. Vulnerabilities include unpatched systems, default system settings and passwords, incorrect permission settings, and vulnerabilities in utilities and applications. Organizations must mitigate these through practices like system hardening, regular patch management, and vulnerability scanning."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Describe the authentication process and techniques.",
    "description": "The authentication process includes identification (e.g., providing a username), authentication (e.g., entering a password), and authorization (e.g., checking permissions). Authentication techniques involve three factors: something you know (passwords), something you are (biometrics), and something you have (smartcards). Multifactor authentication combines techniques from different factors for added security."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Understand the importance of provisioning and deprovisioning user accounts.",
    "description": "Provisioning involves creating authentication credentials and granting appropriate authorizations for new users. Deprovisioning involves removing access when users leave or transfer roles. Effective processes prevent unauthorized access and potential security risks."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Explain the significance of account monitoring.",
    "description": "Regular user account reviews and continuous monitoring for suspicious activity are crucial. Practices include reviewing permissions for accuracy, detecting unauthorized use, and employing behavior-based monitoring to flag risky logins, unusual network locations, and deviations from normal behavior."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Explain third-party access management.",
    "description": "Managing third-party access involves assessing and mitigating risks associated with granting external entities access to sensitive information. Organizations should use detailed legal agreements, perform security assessments, and monitor third-party activities to maintain security."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Describe environmental and physical security controls.",
    "description": "Environmental controls include reliable power, temperature and humidity controls, and fire detection and suppression systems. Physical security controls, such as keycard systems, surveillance, and barriers, prevent unauthorized access to facilities and protect valuable equipment and information."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand human resources security measures.",
    "description": "Measures like background checks, job descriptions, employment agreements, and regular security training help ensure employees act responsibly and securely. Proper handling of employee transfers and terminations is essential to maintain security."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Explain auditing access controls.",
    "description": "Auditing access controls involves evaluating logical access controls, user access provisioning, password management, and employee termination processes. Auditors must also review access logs, incident response procedures, and physical and environmental controls to ensure comprehensive security."
  }
];
